const wx = window.wx

if (!wx) {
  throw new Error('需要依赖weixin-js-sdk')
}

const ANDROID_VERSION = getAndroidVersion()
const IOS_VERSION = getIosVersion()
const APP_STORE_URL =
  'https://apps.apple.com/cn/app/%E5%B0%8F%E6%96%B9-%E6%96%B9%E6%AD%A3%E8%AF%81%E5%88%B8/id1067236066'

/**
 * class 内参数说明
 * @param {String} url 唤起app成功后要跳转的页面、
 * @param {String} title
 * @param {String} des 根据页面类型定义的下载中间页
 * @param {String} xfHref 小方app内展示的页面
 * @param {String} extinfo 微信打开小方app额外传递的参数
 * @param {String} commonDownloadURL 通用下载页地址
 * @param {String} dialogTimer 定时器是否关闭弹窗
 * @param {String} isSupportOpenTag 环境是否适合展示唤起按钮
 */

export default class AppBar {
  constructor(obj) {
    this.env = obj.env || 'test'
    if (typeof nativeObject === 'undefined') {
      // 判断是否在小方webview内
      this.url = obj.url || window.location.href
      this.title = obj.title || '打开小方APP查看完整内容'
      this.des = obj.des || '小方，您的移动财富顾问'
      this.closeAble = obj.closeAble || false
      this.wxSignature = obj.wxSignature || {}
      this.xfHref = ''
      this.encodeXfHref = ''
      this.extinfo = ''
      this.commonDownloadURL = ''
      this.dialogTimer = null
      this.makeSchemaUrl()
      this.bindEvents()
      this.isSupportOpenTag = this.checkEnv()
      this.addNewStyle()
      this.createAppbar()
      this.createCannotOpen()
      if (this.isSupportOpenTag) {
        this.getSignature()
      }
      this.showDownloadBtn()
    }

    // this.report = new window.saReport({
    //   env: this.env || 'test',
    //   debug: false,
    //   // 开启全埋点，默认false
    //   autoTrack: true,
    //   heatmap: {
    //     //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    //     clickmap: 'default',
    //   },
    // })
  }
  changeUrl(value) {
    this.url = value
    this.makeSchemaUrl()
    this.showDownloadBtn()
  }
  // 配置通用下载页路径
  makeSchemaUrl() {
    const protocols = ['http', 'https', 'fzzqxf']
    const matchs = this.url.match(/(\w+):\/\//) || []
    const protocol = matchs[1]
    const isSupportProtocol = protocols.some(item => item === protocol)

    if (!isSupportProtocol) {
      console.error('[openApp] URL 无效')
      return
    }
    if (protocol === 'fzzqxf') {
      /**
       * 打开原生页面
       * 1.extinfo格式为 `scheme=fzzqxf://xxxxxx?param1=编码&param2=编码`
       * 2.通用下载页拼接?url=fzzqxf://xxxxxx?param1=编码&param2=编码
       */
      const nativeUrl = this.url.split('?')[0]
      let params = []
      let encodeParam = ''
      if (this.url.split('?')[1]) {
        params = this.url.split('?')[1].split('&')
      }
      const paramList = params.map(item => {
        const obj = {
          key: item.split('=')[0],
          value: item.split('=')[1],
        }
        return obj
      })
      paramList.forEach((item, index) => {
        if (paramList.length - 1 !== index) {
          encodeParam += `${item.key}=${encodeURIComponent(item.value)}&`
        } else {
          encodeParam += `${item.key}=${encodeURIComponent(item.value)}`
        }
      })
      this.extinfo = `scheme=${nativeUrl}`
      this.xfHref = nativeUrl
      if (paramList && paramList.length > 0) {
        this.extinfo = this.extinfo + '?' + encodeParam
        this.xfHref = nativeUrl + '?' + encodeParam
      }
      this.commonDownloadURL =
        this.env === 'production'
          ? `https://app.foundersc.com/api/financial/h5/view/redirect_app/download.html?url=${this.xfHref}`
          : `https://app-dev-cstest.fzzqxf.com/api/financial/h5/view/redirect_app/download.html?url=${this.xfHref}`
    } else {
      // webview 内打开网页
      /**
       * 1.extinfo内跳转到app的地址需要转义
       * 2.浏览器内打开的地址ios转义，安卓不转义
       */
      let schemeHost
      const redirectUrl = IOS_VERSION ? encodeURIComponent(this.url) : this.url
      this.xfHref = `fzzqxf://browser/?url=${redirectUrl}`
      this.encodeXfHref = `fzzqxf://browser/?url=${encodeURIComponent(this.url)}`
      if (IOS_VERSION) {
        schemeHost = `fzzqxf://webview/finance/?url=${encodeURIComponent(this.url)}`
      } else {
        schemeHost = `fzzqxf://browser/?url=${encodeURIComponent(this.url)}`
      }
      this.extinfo = `scheme=${schemeHost}`
      this.commonDownloadURL =
        this.env === 'production'
          ? `https://app.foundersc.com/api/financial/h5/view/redirect_app/download.html?url=${this.encodeXfHref}`
          : `https://app-dev-cstest.fzzqxf.com/api/financial/h5/view/redirect_app/download.html?url=${this.encodeXfHref}`
    }
  }
  bindEvents() {
    document.addEventListener('WeixinOpenTagsError', e => {
      // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
      this.isSupportOpenTag = false
      console.error('WeixinOpenTagsError', e.detail.errMsg)
    })
    window.addEventListener(
      'pagehide',
      event => {
        if (event.persisted || this.dialogTimer) {
          clearTimeout(this.dialogTimer)
          this.dialogTimer = null
          this.handleDialog(false)
        }
      },
      false
    )
    document.addEventListener('visibilitychange', () => {
      if (document.hidden || this.dialogTimer) {
        clearTimeout(this.dialogTimer)
        this.dialogTimer = null
        this.handleDialog(false)
      }
    })

    document.addEventListener('webkitvisibilitychange', () => {
      if (document.webkitHidden || this.dialogTimer) {
        clearTimeout(this.dialogTimer)
        this.dialogTimer = null
        this.handleDialog(false)
      }
    })
  }
  // 打开或关闭弹窗
  handleDialog(value) {
    const mask = document.getElementsByClassName('download_dialog_mask')[0]
    if (mask) {
      if (value) {
        mask.style.display = 'block'
      } else {
        mask.style.display = 'none'
      }
    }
  }
  checkEnv() {
    if (this.isPC()) {
      return false
    } else {
      let isSysSupport, isweChatSupport
      if (ANDROID_VERSION) {
        isSysSupport = this.versionStringCompare(ANDROID_VERSION, '5.0') >= 0
      } else {
        isSysSupport = this.versionStringCompare(IOS_VERSION, '10.3') >= 0
      }
      if (!isSysSupport) return false

      const weChatVer = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
      if (weChatVer) {
        if (weChatVer[1] === '8.0.2' || weChatVer[1] === '8.0.3') {
          return false
        }
        isweChatSupport = this.versionStringCompare(weChatVer[1], '7.0.12') >= 0
      }
      if (!isweChatSupport) return false
      return true
    }
  }
  isPC() {
    const userAgentInfo = navigator.userAgent
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
    let flag = true
    Agents.forEach(platform => {
      if (userAgentInfo.indexOf(platform) > 0) {
        flag = false
        return flag
      }
    })
    return flag
  }
  // schema按钮点击下载
  pullUpApp() {
    const weChatVer = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
    if (weChatVer) {
      // 若微信浏览器无法使用开放标签，打开引导页
      window.location.href = this.commonDownloadURL
    } else {
      // 非微信尝试直接唤起app
      if (IOS_VERSION) {
        // ios safari打开app
        window.location.href = this.xfHref
        console.log('ios schema唤起')
      } else {
        // 安卓
        const ifr = document.createElement('iframe')
        ifr.src = this.xfHref
        ifr.id = 'openAppBox'
        ifr.style.display = 'none'
        document.body.appendChild(ifr)
        setTimeout(function() {
          document.body.removeChild(ifr)
        }, 3000)
      }
      this.dialogTimer = setTimeout(() => {
        this.handleDialog(true)
      }, 2000)
    }
  }
  // 微信获取appid和签名
  async getSignature() {
    // 如果不为空则获取微信签名成功,否则去请求微信签名
    if (
      this.wxSignature &&
      JSON.stringify(this.wxSignature) !== '{}' &&
      this.wxSignature !== null
    ) {
      this.wxCallback()
      return
    }
  }
  /**
   * 比较两个版本字符串大小
   * @param {String} preVersion 要验证的版本号
   * @param {String} lastVersion 最低版本号
   * @returns 若大于最低版本返回 1，若小于返回 -1， 若相等返回 0
   */
  versionStringCompare(preVersion = '', lastVersion = '') {
    preVersion = preVersion || ''
    lastVersion = lastVersion || ''
    const sources = preVersion.split('.')
    const dests = lastVersion.split('.')
    const maxL = Math.max(sources.length, dests.length)
    let result = 0
    for (let i = 0; i < maxL; i++) {
      const preValue = sources.length > i ? sources[i] : 0
      const preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue)
      const lastValue = dests.length > i ? dests[i] : 0
      const lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue)
      if (preNum < lastNum) {
        result = -1
        break
      } else if (preNum > lastNum) {
        result = 1
        break
      }
    }
    return result
  }
  // 签名信息验证
  wxConfig(info) {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      appId: info.appId, // 必填，公众号的唯一标识
      timestamp: info.timestamp, // 必填，生成签名的时间戳
      nonceStr: info.noncestr, // 必填，生成签名的随机串
      signature: info.signature, // 必填，签名
      jsApiList: ['checkJsApi'], // 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-app'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    })
    this.wxCallback()
  }
  wxCallback() {
    wx.ready(() => {
      this.isSupportOpenTag = true
      this.showDownloadBtn()
      console.log('config信息验证完成')
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
    })

    wx.error(res => {
      this.isSupportOpenTag = false
      console.log('config信息验证失败', res)
      this.showDownloadBtn()
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
    })
  }
  // 添加style
  addNewStyle() {
    const style = document.createElement('style')
    const styleHtml = `
      .appbar {
          display: flex;
          display: -webkit-flex;
          position: fixed;
          top: 0px;
          left: 0px;
          z-index: 98;
          height: 56px;
          background: #f5f6fa;
          width: 100%;
          color: #000;
          padding: 0 16px;
          box-sizing: border-box;
          align-items: center;
          -webkit-box-sizing: border-box;
          font-family: PingFangSC-Regular;
      }
      .appbar img {
          width: 36px;
          height: 36px;
          border-radius: 9px;
          margin-right: 8px;
          display: black;
      }
      .appbar-center {
          flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          flex-direction: column;
      }
      .appbar-right-t2 {
          display: flex;
          align-items: flex-end;
      }
      .appbar-center-title {
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
      }
      .appbar-center-des {
          font-size: 12px;
          line-height: 17px;
          color: #585e70;
          margin-top: 2px;
      }
      .appbar-right-btn {
          display: block;
          width: 80px;
          height: 28px;
          line-height: 28px;
          border-radius: 14px;
          background-color: #0076f8;
          font-size: 13px;
          color: #fcfcfc;
          text-align: center;
          font-weight: 500;
      }
      .appbar-close {
          position: absolute;
          top: 0;
          right: 0;
          width: 10px;
          height: 10px;
          margin: 1px 1px 0 0;
          background: url("https://app-dev-cstest.fzzqxf.com/api/financial/h5/assets/download_from_wechat/imgs/fz_close@3x.png")
              no-repeat left top/100% 100%;
      }
      .download_dialog_mask {
          background-color: rgba(134, 138, 141, 0.5);
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 99;
          display: none;
      }
      .download_dialog {
          background-color: #ffffff;
          text-align: center;
          max-width: 452px;
          border-radius: 8px;
      }
      .download_dialog_center {
          position: fixed;
          top: 50%;
          left: 24px;
          right: 24px;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
      }
      .download_dialog_content {
          font-size: 17px;
          padding: 20px;
      }
      .download_dialog_content h3 {
        font-weight: 700;
        font-size: 22px;
        line-height: 30px;
        color: #000f1a;
        text-align: center;
        padding-bottom: 20px;
      }
      .download_dialog_bottom {
          margin: auto;
          width: 95%;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-around;
      }
      .download_close_btn {
          display: inline-block;
          height: 38px;
          line-height: 38px;
          width: 25%;
          text-align: center;
          color: rgb(234, 32, 18);
          background-color: #ffffff;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          position: relative;
      }
      .download_close_btn:after{
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 200%;
        height: 200%;
        border: 1px solid #818b91;
        -webkit-transform-origin: 0 -0.5px;
        transform-origin: 0 -0.5px;
        -webkit-transform: scale(.5);
        transform: scale(.5);
        border-radius: 8px;
        box-sizing: border-box;
      }
      .download_now_btn {
          display: inline-block;
          height: 38px;
          line-height: 38px;
          width: 65%;
          text-align: center;
          color: #ffffff;
          background-color: rgb(234, 32, 18);
          border: 0.5px solid rgb(234, 32, 18);
          border-radius: 4px;
          font-family: PingFangSC-Regular;
          font-size: 18px;
      }
      .appbar a {
          text-decoration: none;
      }
      .appbar a:link {
          text-decoration: none;
      }
      .appbar a:visited {
          text-decoration: none;
      }
      .appbar a:hover {
          text-decoration: none;
      }
      .appbar a:active {
          text-decoration: none;
      }
    `
    style.innerHTML = styleHtml
    document
      .getElementsByTagName('head')
      .item(0)
      .appendChild(style)
  }
  // 创建底部灰色div层
  createAppbar() {
    const _dialogStr = `
        <div id="appbar-container" class="appbar">
          <img src="https://static.fzzqcdn.com/assets/imgs/fz_logo_radius@3x.png" />
          <div class="appbar-center">
              <div class="appbar-center-title">${this.title}</div>
              <div class="appbar-center-line"></div>
              <div class="appbar-center-des">${this.des}</div>
          </div>
          <div id="_OpenAppBarLaunchBtn">
          </div>
        </div>`
    const appbar = document.createElement('div')
    appbar.innerHTML = _dialogStr
    appbar.id = 'appbar'
    document.getElementsByTagName('body')[0].appendChild(appbar)
    if (this.closeAble) {
      const appbarContainer = document.getElementById('appbar-container')
      const closeAble = document.createElement('em')
      closeAble.className = 'appbar-close'
      appbarContainer.appendChild(closeAble)
      closeAble.addEventListener('click', () => {
        appbar.style.display = 'none'
      })
    }
  }
  // 创建跳转按钮
  showDownloadBtn() {
    const wxOpen = document.getElementById('wxOpenBtn')
    const schemaBtn = document.getElementById('schemaBtn')
    const weChatVer = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
    if (wxOpen) {
      wxOpen.remove()
    }
    if (schemaBtn) {
      schemaBtn.remove()
    }
    if (weChatVer && this.isSupportOpenTag) {
      const launchBtn = document.getElementById('_OpenAppBarLaunchBtn') //获取元素
      const html = `
        <a href="JavaScript:;" style="display:block;">
          <wx-open-launch-app id="wxOpenBtn" appid="wxa4c934f0edb2305d" extinfo="${this.extinfo}">
            <script type="text/wxtag-template">
              <style>.open-app-btn {width:80px;height: 28px;line-height: 28px;margin-top:14px;box-sizing: border-box;font-size: 13px;color: #fcfcfc;;background: #0076f8;;border-radius: 14px;text-align: center;}</style>
              <div class="open-app-btn">立即打开</div>
            </script>
          </wx-open-launch-app>
        </a>`
      launchBtn.innerHTML = html
      const wxOpenBtn = document.getElementById('wxOpenBtn')
      wxOpenBtn.addEventListener('launch', () => {})
      wxOpenBtn.addEventListener('error', err => {
        this.handleDialog(true)
      })
    } else {
      const html = `<a href="JavaScript:;" id="schemaBtn" class="appbar-right-btn">立即打开</a>`
      const schema = document.getElementById('_OpenAppBarLaunchBtn')
      schema.innerHTML = html
      schema.addEventListener('click', () => {
        this.pullUpApp()
      })
    }
  }
  // 创建无法打开弹窗
  createCannotOpen() {
    const _dialogStr = `
        <div class="download_dialog_mask">
          <div class="download_dialog download_dialog_center">
            <div class="download_dialog_content">
              <h3>无法打开？</h3>
              <p>可能是当前应用不支持唤醒我们（如果您尚未安装小方APP，点击立即下载试试吧~）</p>
            </div>
            <div class="download_dialog_bottom">
              <span class="download_close_btn">关闭</span>
              <span class="download_now_btn">立即下载</span>
            </div>
          </div>
        </div>`
    const cannotOpen = document.createElement('div')
    cannotOpen.innerHTML = _dialogStr
    cannotOpen.id = 'cannotOpen'
    document.getElementsByTagName('body')[0].appendChild(cannotOpen)
    const mask = document.getElementsByClassName('download_dialog_mask')[0]
    const close = document.getElementsByClassName('download_close_btn')[0]
    const download = document.getElementsByClassName('download_now_btn')[0]
    mask.style.display = 'none'
    close.addEventListener('click', () => {
      mask.style.display = 'none'
    })
    download.addEventListener('click', () => {
      mask.style.display = 'none'
      if (IOS_VERSION) {
        // iOS 打开 APP store
        const weChatVer = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
        if (weChatVer) {
          const pre = this.versionStringCompare(weChatVer[1], '8.0.13') // 大于等于8.0.13 返回 1
          // const last = this.versionStringCompare(weChatVer[1], '8.0.15') // 大于等于8.0.15 返回 1
          if (pre >= 0) {
            // 8.0.13~8.0.15版本的微信，通过私聊打开链接方式进入详情页，唤起app失败，弹框立即下载会打不开appstore
            window.location.href = this.commonDownloadURL
          } else {
            window.location.href = APP_STORE_URL
          }
        } else {
          window.location.href = APP_STORE_URL
        }
      } else {
        // android 打开通用下载页
        window.location.href = this.commonDownloadURL
      }
    })
  }
}

function getAndroidVersion() {
  const ua = navigator.userAgent.toLowerCase()
  let version = null
  if (ua.indexOf('android') !== -1) {
    const reg = /android [\d._]+/gi
    const vInfo = ua.match(reg)
    version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') //得到版本号 0.0.0
  }
  return version
}

function getIosVersion() {
  const ua = navigator.userAgent.toLowerCase()
  let version = null
  if (ua.match(/cpu iphone os (.*?) like mac os/)) {
    const reg = /os [\d._]+/gi
    const vInfo = ua.match(reg)
    version = (vInfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
  }
  return version
}
